<template>
  <div class="animated fadeIn">
    <basic-heading title="New Attribute">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <attributes-list-form @submit="submit" managed_list_parent_id="managed_list_parent_id"></attributes-list-form>
  </div>
</template>

<script>
import Vue from "vue";
import AttributesListForm from "@/components/lab/attributeslists/AttributesListForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import VueNotifications from "vue-notifications";
import { attributesListsNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { mapGetters } from "vuex";

const attributeListsRepository = LabRepositoryFactory.get("attributeLists");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "AttributesListsAdd",
  components: {
    AttributesListForm,
    BasicHeading,
    HeaderButtonGroup,
  },
  computed: {
    ...mapGetters({ parent: "parentId" }),
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/managed-lists",
            title: "Managed lists",
          },
        ],
      };
    },
    managed_list_parent_id() {
      return this.$route.query.link_id
    }
  },
  methods: {
    submit(payload) {
      const correct_payload = payload.map((item) => {
        const { value, managed_list_id, parent_id } = item;
        return { value, managed_list_id, parent_id };
      });
      const additions = [];
      correct_payload.forEach((attribute) => {
        additions.push(attributeListsRepository.create(attribute));
      });
      return Promise.all(additions)
        .then(() => {
          this.addSuccess();
          this.$router.push(`/managed-lists/${this.parent}`);
        })
        .catch(() => {
          this.addFail();
        });
    },
  },
  notifications: attributesListsNotifications,
};
</script>
